import { render, staticRenderFns } from "./DeliveryInfo.vue?vue&type=template&id=6848cf83&"
import script from "./DeliveryInfo.vue?vue&type=script&lang=js&"
export * from "./DeliveryInfo.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports